import { createSlice } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { setErrorMessage } from "./errors";
import { mapErrorMessage } from "../utils";
import api from "../api";

const initialState = {
  plans: null,
  selected: null,
  loading: false,
  error: null,
};

const insurancePlansSlice = createSlice({
  name: "insurancePlans",
  initialState,
  reducers: {
    fetchInsurancePlansStart(state) {
      state.loading = true;
      state.plans = null;
      state.error = null;
    },
    fetchInsurancePlansSuccess(state, action) {
      state.loading = false;
      state.plans = action.payload;
      state.error = null;
    },
    fetchInsurancePlansFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedInsurancePlan(state, action) {
      state.selected = action.payload;
    },
    setSelectedInsurancePlanAuto(state, action) {
      state.selected = action.payload;
    },
  },
});

const { actions, reducer } = insurancePlansSlice;

export const {
  fetchInsurancePlansStart,
  fetchInsurancePlansSuccess,
  fetchInsurancePlansFailure,
  setSelectedInsurancePlan,
  setSelectedInsurancePlanAuto,
} = actions;

export const fetchInsurancePlans =
  (productId, activityId) => async (dispatch, getState) => {
    try {
      // TODO: Don't fetch the same plan again
      dispatch(fetchInsurancePlansStart());
      const { token } = getState().auth;
      let params = { productId: productId, channelId: 341 };

      if (activityId) {
        params = { ...params, activityId };
      }
      const { data } = await api.get("/seguros/planes/cobertura/ch/PDS", {
        params: params,
        headers: { Authorization: `Bearer ${token}` },
      });

      dispatch(fetchInsurancePlansSuccess(data.insurancePlans || []));
    } catch (error) {
      dispatch(fetchInsurancePlansFailure());
      dispatch(setErrorMessage(mapErrorMessage("systemError")));
      dispatch(push("/error"));

      return;
    }
  };

export default reducer;
